import type { StateCreator } from 'zustand';
import type { AlertsSlices } from '.';

interface TriggerTourSliceState {
  tourModalRun: boolean;
  tourRun: boolean;
  tourActive: boolean;
  tourStepIndex: number;
  setTourModalRun: (tourModalRun: boolean) => void;
  setTourRun: (run: boolean) => void;
  setTourActive: (tourActive: boolean) => void;
  setTourStepIndex: (index: number) => void;
}

type StateCreatorTriggerTour = StateCreator<AlertsSlices, [['zustand/devtools', never]], [], TriggerTourSliceState>;

const createTriggerTourSlice: StateCreatorTriggerTour = (set) => ({
  tourModalRun: false,
  tourRun: false,
  tourActive: false,
  tourStepIndex: 0,
  setTourModalRun: (tourModalRun) => set({ tourModalRun }),
  setTourRun: (tourRun) => set({ tourRun }),
  setTourActive: (tourActive) => set({ tourActive }),
  setTourStepIndex: (tourStepIndex) => set({ tourStepIndex }),
});

export type { TriggerTourSliceState };
export default createTriggerTourSlice;
